import React from "react";
import ComponentContainer from "../components/ComponentContainer";
import NumerableList from "../components/NumerableList";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      <ComponentContainer>
        <h1>Политика конфиденциальности</h1>
        <h2 className="mb-2">Главная | Политика конфиденциальности</h2>
        <NumerableList>
          <ol className="nested-list">
            <li>
              <div className="head gradient-text font-size-1-75 semi-bold">
                ОБЩИЕ ПОЛОЖЕНИЯ
              </div>
              <p className="mb-2 mt-1">
                Данная политика обработки персональных данных (далее —
                «Политика») составлена в соответствии с Федеральным законом №
                152-ФЗ от 27.07.2006 «О персональных данных» и регулирует
                принципы и методы обработки персональной информации, а также
                меры по обеспечению ее безопасности, которые принимаются
                проектом <b>MEGALODON</b> (далее — «Оператор»).
              </p>
              <ol>
                <li>
                  Оператор стремится соблюдать все права и свободы личности при
                  обработке персональных данных, включая защиту частной жизни,
                  семейной тайны и других прав.
                </li>
                <li>
                  Политика охватывает все данные, которые могут быть собраны о
                  посетителях веб-сайта{" "}
                  <Link to={"https://the-megalodon.com"}>
                    https://the-megalodon.com
                  </Link>{" "}
                  (далее — «Сайт»), а также о пользователях мобильных
                  приложений, если они имеются.
                </li>
              </ol>
            </li>
            <li>
              <div className="head gradient-text font-size-1-75 semi-bold">
                ОСНОВНЫЕ ПОНЯТИЯ, ИСПОЛЬЗУЕМЫЕ В ПОЛИТИКЕ
              </div>
              <ol>
                <li>
                  <b>Автоматизированная обработка данных</b> — обработка
                  персональной информации с использованием вычислительных
                  средств.
                </li>
                <li>
                  <b>Блокировка персональных данных</b> — временная приостановка
                  обработки персональной информации (за исключением случаев,
                  когда дальнейшая обработка необходима для уточнения данных).
                </li>
                <li>
                  <b>Веб-сайт</b> — совокупность графических и информационных
                  материалов, а также программного обеспечения и баз данных,
                  которые делают их доступными через интернет по адресу{" "}
                  <Link to={"https://the-megalodon.com"}>
                    https://the-megalodon.com.
                  </Link>
                </li>
                <li>
                  <b>Информационная система персональных данных</b> — система
                  данных, которая включает в себя персональную информацию, и
                  технологические средства, которые обеспечивают обработку этих
                  данных.
                </li>
                <li>
                  <b>Обезличивание данных</b> — действия, которые делают
                  невозможным определение конкретного Пользователя, если не
                  использовать дополнительные сведения.
                </li>
                <li>
                  <b>Обработка персональных данных</b> — любые операции с
                  персональными данными, включая их сбор, хранение, обновление,
                  передачу, обезличивание и уничтожение.
                </li>
                <li>
                  <b>Оператор</b> — юридическое или физическое лицо, которое
                  самостоятельно или в сотрудничестве с другими лицами
                  организует и осуществляет обработку персональных данных.
                </li>
                <li>
                  <b>Персональные данные</b> — информация, которая может быть
                  прямо или косвенно связана с конкретным Пользователем Сайта{" "}
                  <Link to={"https://the-megalodon.com"}>
                    https://the-megalodon.com.
                  </Link>
                </li>
                <li>
                  <b>Пользователь</b> — любое лицо, которое посещает веб-сайт{" "}
                  <Link to={"https://the-megalodon.com"}>
                    https://the-megalodon.com.
                  </Link>
                </li>
                <li>
                  <b>Предоставление персональных данных</b> — действия,
                  направленные на раскрытие персональной информации
                  определенному кругу лиц.
                </li>
                <li>
                  <b>Распространение персональных данных</b> — действия по
                  раскрытию данных неопределенному кругу лиц.
                </li>
                <li>
                  <b>Уничтожение персональных данных</b> — действия, которые
                  ведут к безвозвратному удалению данных, что исключает
                  возможность их восстановления.
                </li>
              </ol>
            </li>
            <li>
              <div className="head gradient-text font-size-1-75 semi-bold">
                ОБРАБОТКА ПЕРСОНАЛЬНЫХ ДАННЫХ
              </div>
              <ol>
                <li>
                  На Сайте{" "}
                  <Link to={"https://the-megalodon.com"}>
                    https://the-megalodon.com
                  </Link>{" "}
                  не производится сбор персональных данных, за исключением
                  случаев, когда Пользователь самостоятельно предоставляет
                  информацию через специальные формы или через сторонние
                  сервисы, такие как Steam, Google или Facebook.
                </li>
                <li>
                  Пользователи могут предоставить следующие данные:
                  <ul>
                    <li>
                      <b>Профиль Steam</b> (включая имя, ID и другую информацию
                      из аккаунта Steam);
                    </li>
                    <li>
                      <b>Электронная почта</b> (для получения уведомлений и
                      рассылок);
                    </li>
                    <li>
                      <b>IP-адрес, данные о браузере, деятельность на Сайте.</b>
                    </li>
                  </ul>
                </li>
                <li>
                  Также Оператор может собирать данные о действиях пользователей
                  через файлы <b>cookie</b> и другие инструменты аналитики
                  (например, Google Analytics, Яндекс.Метрика).
                </li>
                <li>
                  Персональные данные, которые Пользователи могут указать в
                  своих настройках (например,{" "}
                  <b>Профиль Discord, ID Discord, Пол, О себе</b>), не
                  проверяются на достоверность и актуальность.
                </li>
              </ol>
            </li>
            <li>
              <div className="head gradient-text font-size-1-75 semi-bold">
                ЦЕЛИ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ
              </div>
              <ol>
                <li>
                  Обработка персональных данных осуществляется с целью:
                  <ul>
                    <li>
                      Обеспечения корректной работы Сайта и предоставления всех
                      его услуг.
                    </li>
                    <li>
                      Улучшения пользовательского опыта и качества контента.
                    </li>
                    <li>
                      Отправки уведомлений, предложений, рекламных материалов.
                    </li>
                  </ul>
                </li>
                <li>
                  Обезличенные данные, получаемые через cookie-файлы и другие
                  методы анализа, используются для оценки посещаемости Сайта и
                  улучшения его функционала.
                </li>
              </ol>
            </li>
            <li>
              <div className="head gradient-text font-size-1-75 semi-bold">
                ПРАВОВЫЕ ОСНОВАНИЯ ОБРАБОТКИ ДАННЫХ
              </div>
              <ol>
                <li>
                  Оператор обрабатывает персональные данные только в случае,
                  если:
                  <ul>
                    <li>
                      Пользователь выразил согласие на обработку своих данных
                      (например, через настройки браузера или согласие на
                      использование cookie).
                    </li>
                    <li>
                      Обработка данных необходима для выполнения условий
                      соглашений между Оператором и Пользователем.
                    </li>
                  </ul>
                </li>
              </ol>
            </li>
            <li>
              <div className="head gradient-text font-size-1-75 semi-bold">
                МЕРЫ ПО ЗАЩИТЕ ПЕРСОНАЛЬНЫХ ДАННЫХ
              </div>
              <ol>
                <li>
                  Оператор применяет все необходимые меры для защиты
                  персональных данных от несанкционированного доступа, утраты
                  или уничтожения, а также других рисков.
                </li>
                <li>
                  Персональная информация Пользователей не передается третьим
                  сторонам, за исключением случаев, прямо предусмотренных
                  законодательством Российской Федерации.
                </li>
                <li>
                  Все персональные данные хранятся в защищенных системах, доступ
                  к которым ограничен только уполномоченным сотрудникам
                  Оператора.
                </li>
              </ol>
            </li>
            <li>
              <div className="head gradient-text font-size-1-75 semi-bold">
                ПЛАТЕЖНЫЕ СИСТЕМЫ И ОБРАБОТКА ПЛАТЕЖЕЙ
              </div>
              <ol>
                <li>
                  Для обработки платежей Оператор использует сторонние платёжные
                  системы (например, VISA, MasterCard, Qiwi, МИР), которые
                  гарантируют безопасность транзакций. Все платежи проходят
                  через защищенные каналы с применением технологии 3D-Secure для
                  дополнительной аутентификации.
                </li>
              </ol>
            </li>
            <li>
              <div className="head gradient-text font-size-1-75 semi-bold">
                ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ
              </div>
              <ol>
                <li>
                  Оператор имеет право в любое время обновить настоящую
                  Политику, размещая актуальную версию на Сайте. Изменения
                  вступают в силу с момента их публикации.
                </li>
                <li>
                  Последняя версия Политики доступна для ознакомления по адресу:{" "}
                  <Link to={"https://the-megalodon.com/privacy-policy"}>
                    https://the-megalodon.com/privacy-policy.
                  </Link>
                </li>
                <li>
                  В случае возникновения вопросов по обработке персональных
                  данных, Пользователь может обратиться к Оператору, используя
                  контактные данные, указанные на Сайте.
                </li>
              </ol>
            </li>
          </ol>
        </NumerableList>
      </ComponentContainer>
    </div>
  );
};

export default PrivacyPolicy;
